import request from '../../js/lib/request';
import envVar from '../../js/lib/envVar';
import currentLang from '../../js/lib/currentLang';
import Debounce from '../../js/lib/debounce';

const techDir = document.getElementById('TechDirectory');

const options = {
	headers: {
		"content-type": "application/json; charset=utf-8"
	}
};

if(techDir)
{
	const initUrl = envVar({
		backendPath: '/TechDirectoryPage/CompanyProfiles',
	});

	const techdirectoryVue = new Vue({
		el: '#TechDirectory',
		data: {
			collection: '',
		},
		mounted: function() {
			const self = this;

			request().get(initUrl).then(function(response) {
				self.collection = response;
			});
		},
		methods: {
			search: function (event) {
				const self = this;
				request().get(initUrl).then(function (response) {
					self.collection = response;
				});
			}
		}
	});
}



// WEBPACK FOOTER //
// ../components/tech-directory/tech-directory.js